// Billing adapter selector — the rest of the app only ever imports from here.
// Swapping RevenueCat for another provider means changing this file only.

import { Capacitor } from "@capacitor/core";
import { createWebBilling } from "./webBilling";
import { createRevenueCatBilling } from "./revenuecatBilling";

let instance = null;

export const getBilling = () => {
  if (!instance) {
    instance =
      Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android"
        ? createRevenueCatBilling()
        : createWebBilling();
  }
  return instance;
};
